var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "checkout__body", attrs: { id: "hide_header_footer" } },
    [
      _c(
        "div",
        {
          staticClass: "checkout__body__block",
          attrs: { id: "payment-section" },
        },
        [
          _c("div", { staticClass: "checkout__body__block__usp" }, [
            _c("div", { staticClass: "checkout__body__block__usp__entry" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "17",
                    height: "16",
                    viewBox: "0 0 17 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6.1265 11.1256L3.3497 8.0016C3.24404 7.88257 3.09542 7.81039 2.93654 7.80094C2.77766 7.79149 2.62153 7.84554 2.5025 7.9512C2.38347 8.05686 2.31129 8.20548 2.30184 8.36436C2.29239 8.52324 2.34644 8.67937 2.4521 8.7984L5.6521 12.3984C5.70642 12.4595 5.77267 12.5089 5.84676 12.5435C5.92086 12.5781 6.00124 12.5972 6.08298 12.5995C6.16471 12.6019 6.24608 12.5876 6.32207 12.5574C6.39807 12.5272 6.46709 12.4818 6.5249 12.424L14.9249 4.024C15.0309 3.91026 15.0886 3.75982 15.0858 3.60438C15.0831 3.44894 15.0201 3.30063 14.9102 3.1907C14.8003 3.08077 14.652 3.0178 14.4965 3.01506C14.3411 3.01232 14.1906 3.07002 14.0769 3.176L6.1265 11.1256Z",
                      fill: "#19B600",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v("Lage kosten per deelnemer")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "checkout__body__block__usp__entry" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "17",
                    height: "16",
                    viewBox: "0 0 17 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6.1265 11.1256L3.3497 8.0016C3.24404 7.88257 3.09542 7.81039 2.93654 7.80094C2.77766 7.79149 2.62153 7.84554 2.5025 7.9512C2.38347 8.05686 2.31129 8.20548 2.30184 8.36436C2.29239 8.52324 2.34644 8.67937 2.4521 8.7984L5.6521 12.3984C5.70642 12.4595 5.77267 12.5089 5.84676 12.5435C5.92086 12.5781 6.00124 12.5972 6.08298 12.5995C6.16471 12.6019 6.24608 12.5876 6.32207 12.5574C6.39807 12.5272 6.46709 12.4818 6.5249 12.424L14.9249 4.024C15.0309 3.91026 15.0886 3.75982 15.0858 3.60438C15.0831 3.44894 15.0201 3.30063 14.9102 3.1907C14.8003 3.08077 14.652 3.0178 14.4965 3.01506C14.3411 3.01232 14.1906 3.07002 14.0769 3.176L6.1265 11.1256Z",
                      fill: "#19B600",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v("Trainingen duren 1,5 uur")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "checkout__body__block__usp__entry" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "17",
                    height: "16",
                    viewBox: "0 0 17 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6.1265 11.1256L3.3497 8.0016C3.24404 7.88257 3.09542 7.81039 2.93654 7.80094C2.77766 7.79149 2.62153 7.84554 2.5025 7.9512C2.38347 8.05686 2.31129 8.20548 2.30184 8.36436C2.29239 8.52324 2.34644 8.67937 2.4521 8.7984L5.6521 12.3984C5.70642 12.4595 5.77267 12.5089 5.84676 12.5435C5.92086 12.5781 6.00124 12.5972 6.08298 12.5995C6.16471 12.6019 6.24608 12.5876 6.32207 12.5574C6.39807 12.5272 6.46709 12.4818 6.5249 12.424L14.9249 4.024C15.0309 3.91026 15.0886 3.75982 15.0858 3.60438C15.0831 3.44894 15.0201 3.30063 14.9102 3.1907C14.8003 3.08077 14.652 3.0178 14.4965 3.01506C14.3411 3.01232 14.1906 3.07002 14.0769 3.176L6.1265 11.1256Z",
                      fill: "#19B600",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", [_vm._v("Interactief en hoge kwaliteit")]),
            ]),
          ]),
          _vm._v(" "),
          _vm.reviews && _vm.reviews.length > 0
            ? _c(
                "div",
                { staticClass: "checkout__body__block__reviews" },
                _vm._l(_vm.reviews, function (review) {
                  return _c(
                    "div",
                    { staticClass: "checkout__body__block__reviews__entry" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "checkout__body__block__reviews__entry__row",
                        },
                        [
                          review.reviewer_img
                            ? _c("img", {
                                attrs: {
                                  src: review.reviewer_img.url,
                                  alt: "Devrim van Elteren",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "checkout__body__block__reviews__entry__column",
                            },
                            [
                              _c("h3", {
                                domProps: {
                                  textContent: _vm._s(review.reviewer_name),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "checkout__body__block__reviews__entry__stars",
                                },
                                _vm._l(parseInt(review.amount), function (i) {
                                  return _c(
                                    "svg",
                                    {
                                      key: i,
                                      attrs: {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M7.19371 2.101C7.26805 1.95044 7.38302 1.82368 7.52563 1.73504C7.66824 1.64641 7.8328 1.59943 8.00071 1.59943C8.16862 1.59943 8.33319 1.64641 8.4758 1.73504C8.61841 1.82368 8.73338 1.95044 8.80771 2.101L10.3287 5.183L13.7297 5.678C13.896 5.70198 14.0522 5.77201 14.1807 5.88017C14.3093 5.98834 14.405 6.13031 14.457 6.29004C14.509 6.44976 14.5153 6.62086 14.4751 6.78397C14.435 6.94708 14.35 7.09569 14.2297 7.213L11.7677 9.612L12.3487 12.999C12.3772 13.1646 12.3587 13.3348 12.2955 13.4904C12.2322 13.646 12.1267 13.7808 11.9908 13.8796C11.8549 13.9783 11.6941 14.0371 11.5265 14.0492C11.359 14.0612 11.1914 14.0262 11.0427 13.948L8.00071 12.348L4.95871 13.948C4.81005 14.0262 4.64246 14.0612 4.47491 14.0492C4.30736 14.0371 4.14654 13.9783 4.01065 13.8796C3.87475 13.7808 3.7692 13.646 3.70595 13.4904C3.64269 13.3348 3.62425 13.1646 3.65271 12.999L4.23271 9.612L1.77271 7.212C1.65278 7.09472 1.56801 6.94626 1.52797 6.78337C1.48793 6.62048 1.49421 6.44963 1.5461 6.29012C1.59799 6.13061 1.69342 5.98877 1.82163 5.88061C1.94985 5.77245 2.10574 5.70227 2.27171 5.678L5.67171 5.183L7.19371 2.101Z",
                                          fill: "#EC0055",
                                        },
                                      }),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "checkout__body__block__reviews__entry__text",
                        domProps: { textContent: _vm._s(review.reviewer_body) },
                      }),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout__body__block__overview",
              attrs: { id: "overview" },
            },
            [
              _c("h2", [_vm._v("Overzicht bestelling")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n        Bij een voorlopige boeking is het mogelijk dat er contact met je wordt opgenomen om een andere datum\n        af te spreken.\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checkout__body__section",
                  attrs: { id: "table-wrapper" },
                },
                [
                  _c("table", [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.checkoutData.cart_items, function (item) {
                        return _c("tr", { key: item.key }, [
                          _c("td", { attrs: { id: "name" } }, [
                            _vm._v(_vm._s(item.session_name)),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { id: "status" } }, [
                            _vm._v(
                              _vm._s(
                                item.is_definitive == true
                                  ? "Definitief"
                                  : "Voorlopig"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { id: "type" } }, [
                            _vm._v(_vm._s(_vm.ucFirst(item.session_type))),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { id: "date" } }, [
                            _vm._v(_vm._s(_vm.stringToDate(item.date))),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { id: "timespan" } }, [
                            _vm._v(_vm._s(_vm.formattedTimespan(item))),
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { id: "price" } }, [
                            _vm._v(
                              _vm._s(_vm.$root.moneyFormat(item.cart_price))
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__body__block__total" }, [
            _c("h3", [_vm._v("Totale kosten")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "checkout__body__section",
                attrs: { id: "total-content" },
              },
              [
                _c("div", { staticClass: "checkout__row" }, [
                  _c("h5", [_vm._v("Aantal trainingen")]),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(_vm._s(_vm.checkoutData.cart_items.length)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "checkout__row" }, [
                  _c("h5", [_vm._v("Subtotaal")]),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.$root.moneyFormat(
                          _vm.checkoutData.total_cart_price_excl_tax,
                          0
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.coupons, function (coupon) {
                  return _vm.coupons.length > 0
                    ? _c("div", { staticClass: "checkout__row" }, [
                        _c("h5", [
                          _vm._v("Kortingsbon: " + _vm._s(coupon.code)),
                        ]),
                        _vm._v(" "),
                        _c("h5", {
                          domProps: {
                            innerHTML: _vm._s(
                              "- " +
                                _vm.$root.moneyFormat(
                                  parseFloat(coupon.discount)
                                )
                            ),
                          },
                        }),
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.tax > 0
                  ? _c("div", { staticClass: "checkout__row" }, [
                      _c("h5", [_vm._v("BTW (21%)")]),
                      _vm._v(" "),
                      _c("h5", [
                        _vm._v(
                          _vm._s(_vm.$root.moneyFormat(parseFloat(_vm.tax)))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "checkout__row",
                    attrs: { id: "total-price" },
                  },
                  [
                    _c("h5", [_vm._v("Totaal")]),
                    _vm._v(" "),
                    _c("h5", [
                      _vm._v(
                        _vm._s(
                          _vm.$root.moneyFormat(parseFloat(_vm.totalPrice))
                        )
                      ),
                    ]),
                  ]
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "checkout__body__block__payment" },
            [
              _vm.totalPrice > 0
                ? [
                    _c("h3", [_vm._v("Betaalmethode")]),
                    _vm._v(" "),
                    _c(
                      "TransitionGroup",
                      {
                        staticClass: "checkout__body__block__payment__methods",
                        attrs: { mode: "out-in", name: "view" },
                      },
                      _vm._l(
                        _vm.paymentGateways,
                        function (paymentGateway, index) {
                          return _c(
                            "div",
                            {
                              key: paymentGateway.title,
                              staticClass:
                                "checkout__body__block__payment__methods__entry",
                              class: { active: _vm.selectedPayment == index },
                              on: {
                                click: () => {
                                  _vm.selectPayment(index)
                                },
                              },
                            },
                            [
                              _vm.getPaymentImage(paymentGateway.id)
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.getPaymentImage(
                                        paymentGateway.id
                                      ),
                                      alt:
                                        "Betalen met " + paymentGateway.title,
                                    },
                                  })
                                : paymentGateway.icon
                                ? _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(paymentGateway.icon),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(paymentGateway.title)),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.agreementUrl && _vm.privacyUrl
                ? _c(
                    "div",
                    {
                      staticClass: "checkout__body__block__payment-agreements",
                    },
                    [
                      _vm.agreementUrl
                        ? _c("div", { staticClass: "agreement__wrapper" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.agreementEnabled,
                                  expression: "agreementEnabled",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                required: "",
                                name: "agreement",
                                id: "agreement",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.agreementEnabled)
                                  ? _vm._i(_vm.agreementEnabled, null) > -1
                                  : _vm.agreementEnabled,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.agreementEnabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.agreementEnabled = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.agreementEnabled = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.agreementEnabled = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "agreement" } }, [
                              _vm._v("Ik ga akkoord met de "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.agreementUrl,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "algemene voorwaarden\n              *"
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.privacyUrl
                        ? _c("div", { staticClass: "privacy__wrapper" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.privacyEnabled,
                                  expression: "privacyEnabled",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                required: "",
                                name: "privacy",
                                id: "privacy",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.privacyEnabled)
                                  ? _vm._i(_vm.privacyEnabled, null) > -1
                                  : _vm.privacyEnabled,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.privacyEnabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.privacyEnabled = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.privacyEnabled = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.privacyEnabled = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "privacy" } }, [
                              _vm._v("Ik ga akkoord met de "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.privacyUrl,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("privacy verklaring\n              *")]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "controls__wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "previous-button",
                    on: { click: _vm.prevPage },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "25",
                          viewBox: "0 0 24 25",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M10.7335 20.29C10.8785 20.4213 11.0691 20.4907 11.2646 20.4834C11.4601 20.4761 11.645 20.3927 11.7799 20.2511C11.9148 20.1094 11.989 19.9206 11.9866 19.725C11.9843 19.5294 11.9057 19.3425 11.7675 19.204L5.51648 13.25H20.2505C20.4494 13.25 20.6402 13.171 20.7808 13.0303C20.9215 12.8897 21.0005 12.6989 21.0005 12.5C21.0005 12.3011 20.9215 12.1103 20.7808 11.9697C20.6402 11.829 20.4494 11.75 20.2505 11.75H5.51648L11.7675 5.79502C11.9057 5.65658 11.9843 5.46962 11.9866 5.27402C11.989 5.07841 11.9148 4.88964 11.7799 4.74797C11.645 4.6063 11.4601 4.52293 11.2646 4.51566C11.0691 4.50838 10.8785 4.57777 10.7335 4.70902L3.31348 11.776C3.15108 11.9301 3.04539 12.1344 3.01348 12.356C2.99518 12.4515 2.99552 12.5497 3.01448 12.645C3.0466 12.8662 3.15228 13.0702 3.31448 13.224L10.7335 20.29Z",
                            fill: "#21386E",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("Vorige stap")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "checkout__primary-button",
                    attrs: {
                      disabled:
                        (_vm.selectedPayment === null && _vm.totalPrice > 0) ||
                        !_vm.agreementEnabled ||
                        !_vm.privacyEnabled ||
                        _vm.creatingOrder,
                    },
                    on: { click: _vm.createOrder },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.totalPrice > 0 ? "Betalen" : "Bestellen")
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          fill: "none",
                          height: "13",
                          viewBox: "0 0 9 13",
                          width: "9",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M0.357846 12.3798C0.454056 12.4298 0.562077 12.4527 0.670315 12.446C0.778554 12.4393 0.882922 12.4032 0.972219 12.3417L8.70392 6.989C8.78292 6.93426 8.84748 6.86119 8.89208 6.77605C8.93667 6.69091 8.95996 6.59623 8.95996 6.50012C8.95996 6.404 8.93667 6.30932 8.89208 6.22418C8.84748 6.13904 8.78292 6.06597 8.70392 6.01123L0.972219 0.658521C0.882991 0.596782 0.778575 0.560628 0.670274 0.553976C0.561974 0.547323 0.453918 0.570424 0.357805 0.620778C0.261691 0.671131 0.181185 0.746819 0.125001 0.839645C0.0688181 0.93247 0.0390991 1.0389 0.0390625 1.1474V11.8528C0.0390446 11.9614 0.0687421 12.0679 0.124936 12.1608C0.18113 12.2537 0.261677 12.3294 0.357846 12.3798Z",
                            fill: "white",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Training")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", [_vm._v("Soort")]),
        _vm._v(" "),
        _c("th", [_vm._v("Datum")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tijd")]),
        _vm._v(" "),
        _c("th", [_vm._v("Kosten")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/Views/PaymentView.vue